<!-- <p *ngIf="this.currentFlats">{{ this.appartments }}{{ this.currentFlats.status }}</p> -->

<div @anim class="data-on-click" *ngIf="this.currentFlatsOnClickShow" [class.full-width-panel]="fulWidthPanel"  (click)="stopPropagationF($event)">

  <div class="share-button-holder">
    <input type="text" [value]="routeNavigate" class="hide-url" #userinput>
    <a class="fa-whatsapp share-whatsapp">
      <div class="whatsapp-menu-trigger" (click)="showPhoneF()">
        <ul @slideUp class="whatsapp-menu" *ngIf="showPhone">
          <li (click)="showPhoneNumber = !showPhoneNumber"><a href="javascript:;">
              <div class="text phone"></div>
              <div class="title">{{ 'PHONE-NUMBER' | translate }}</div>
            </a></li>
          <li><a href="https://api.whatsapp.com/send?&text={{ routeNavigate }}" target="_blank">
              <div class="text list-users"></div>
              <div class="title">{{ 'USER-LIST' | translate }}</div>
            </a></li>
        </ul>
        <!-- <div class="whatsapp-menu" *ngIf="showPhone">
          <div class="title" (click)="showPhoneNumber = !showPhoneNumber"><a href="javascript:;">מספר טלפון</a></div>
          <div class="text"> <a href="https://api.whatsapp.com/send?&text={{ routeNavigate + '?m=all' }}" target="_blank">רשימת
            משתמשים</a> </div> 
          </div> -->
      </div>

      <div @slideUp class="add-phone-numbrer" *ngIf="showPhoneNumber" (click)="stopPropagationF($event)">
        <mat-form-field appearance="fill">
          <select class="area-code" matNativeControl required (change)="onChangeAreaCode($event.value)">
            <option type="number" *ngFor="let code of areaCodes" value="{{ code }}">{{ code
              }}
            </option>
          </select>
        </mat-form-field>

        <input [(ngModel)]='phoneNumber' type="number" pattern="/[^\d+]/" placeholder="050 1111111" name="phone-number">
        <textarea [(ngModel)]='freeText' type="text" placeholder="{{ 'FREE-TEXT' | translate }}"
          name="free-text"></textarea>
        <a class="btn"
          href="javascript:;"
          target="_blank" (click)="whatsapMessageSend()">שלח</a>
        <!-- <a class="btn sehel" *ngIf="sehelUser" (click)="sendWhatsapSehel(phoneNumber)" href="javascript:;">שלח</a> -->
      </div>
    </a>


    <button (click)="copyInputMessage(userinput)" class="share-url"></button>
    <!-- <div *ngIf="this.user" class="offer-holder">
      <button *ngIf="this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin"
        (click)="openDialog()" class="offer-btn"></button>
    </div> -->

    <span class="show-coppy-note" [class.active]=showCopyNote>{{ 'COPIED' | translate }}</span>


  </div>
  <div class="top-panel">
    <div class="title-holder">
      <div class="icon-holder flat-number-title"></div>
      <div class="title"><span>{{ 'FLAT-NUMBER' | translate }}</span> {{
        this.currentFlatsOnClick.number }}</div>
  </div>
  <!-- <a href="javscript:;" class="full-width-button" (click)="bigPanel()" [class.reduce]="fulWidthPanel"></a> -->
  <a href="javscript:;" class="close-section" (click)="togglePanel()"></a>
  </div>
  <ul class="data-on-click general-flat-propeties n" id="data-on-click">
    <li class="general-flat-number flat-number-title"> <span>{{ 'FLAT-NUMBER' | translate }}</span> {{
      this.currentFlatsOnClick.number }}</li>
    <li class="floor-title"> <span>{{ 'FLOOR' | translate }}</span> {{ this.currentFlatsOnClick.floorNumber }}</li>
    <li class="flat-size-title">
      <span>{{ 'APARTMENT-AREA' | translate }}</span> {{ this.currentFlatsOnClick.flatSize }}
    </li>
    <li class="general-flat-area balconies-size-title">
      <span>{{ 'BALCONIES-AREA' | translate }}</span> {{ this.currentFlatsOnClick.balconiesSize }}
    </li>
    <li class="general-flat-room-quantity numberOfRooms-title">
      <span>{{ 'NUMBER-OF-ROOMS' | translate }}</span> {{ this.currentFlatsOnClick.numberOfRooms }}
    </li>
  </ul>
  <div class="mat-tab-holder">
    <mat-tab-group mat-align-tabs="start" [class.active]="toggleMenuTab" class="properties-on-the-fly">


      <mat-tab *ngIf="this.currentFlatsOnClick.flatInterior">
        <ng-template mat-tab-label>
          <div class="lable-holder" (click)="openMenuMatTab()">
            <mat-icon class="interior-pano-icon"></mat-icon>
            {{ 'INTERIOR-TOUR' | translate }}
          </div>
        </ng-template>
        <div class="panorama-holder">
          <div class="view-from-floor-panorama-holder flat-interior"
            [innerHtml]="'<iframe src=' + this.currentFlatsOnClick.flatInterior + '></iframe>' | safe: 'html'">
          </div>
        </div>
        <div class="increase-size">
          <span></span>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="lable-holder" (click)="openMenuMatTab()">
            <mat-icon class="spirikal-pano-icon"></mat-icon>{{ 'SPIRIKAL' | translate }}
          </div>
        </ng-template>
        <div class="collection da-iframe panorama-holder">
          <div *ngIf="this.mainSpiricalSrcUpdated" class="view-from-floor-panorama-holder"
            [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '></iframe>' | safe: 'html'">
          </div>
        </div>
        <div class="increase-size">
          <span></span>
        </div>
      </mat-tab>

      <mat-tab *ngIf="this.panoramaView">
        <ng-template mat-tab-label>
          <div class="lable-holder" (click)="openMenuMatTab()">
            <mat-icon class="floor-pano-icon"></mat-icon>
            {{ 'VIEW' | translate }}
          </div>
        </ng-template>

        <div class="collection" class="panorama-holder"> 
          <div *ngIf="this.mainSpiricalSrcUpdated && !this.isUrl" [attr.data-isUrl]="this.isUrl" [attr.data-isUrl]="panoramaView" class="view-from-floor-panorama-holder"
            [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '?s=' + panoramaView + '></iframe>' | safe: 'html'">
          </div>
          <div *ngIf="this.mainSpiricalSrcUpdated && this.isUrl" class="view-from-floor-panorama-holder"
            [innerHtml]="'<iframe src=' + this.currentFlatsOnClick.curFloorPanorama + '></iframe>' | safe: 'html'">
          </div>
        </div>
        <div class="increase-size">
          <span></span>
        </div>
      </mat-tab>

      <mat-tab class="plan-holder">
        <ng-template mat-tab-label>
          <div class="lable-holder" (click)="openMenuMatTab()">
            <mat-icon class="plan-icon"></mat-icon>
            {{ 'PLAN' | translate }}
          </div>
        </ng-template>
        <app-gallery *ngIf="this.currentFlatsOnClick.protoId" [galleryId]="'1'" [section]="currentFlatsOnClick.protoId+'images'" [resizeDrag]="true" [autoPlay]="true"
          [showThumbs]="true" class="list-static simple-gall build-simple-gal plan-holder"></app-gallery>

        <app-gallery [galleryId]="'1'" [section]="currentFlatsOnClick.planeUrl" [resizeDrag]="true" [autoPlay]="true"
          [showThumbs]="true" class="list-static simple-gall build-simple-gal plan-holder">
        </app-gallery>

        <div class="increase-size">
          <span></span>
        </div>
      </mat-tab>

      <mat-tab *ngIf="withDrawing&& buildType !== 'office'">
        <ng-template mat-tab-label>
          <div class="lable-holder" (click)="openMenuMatTab('plan')">
            <mat-icon class="plan-icon"></mat-icon>
            {{ 'FLOOR-PLAN' | translate }}
          </div>
        </ng-template>

        <app-gallery *ngIf="!ifFloorIdIsFloorNumber(this.curFloorId)" [galleryId]="'1'" [attr.data-id]="this.curFloorId" [section]="this.curFloorId+'floordrawing-SVG'" [autoPlay]="true"
        [showThumbs]="true"
        class="list-static simple-gall svg-gallery build-simple-gal plan-holder"></app-gallery>
        <app-gallery *ngIf="ifFloorIdIsFloorNumber(this.curFloorId)" [galleryId]="'1'" [attr.data-id]="this.curFloorId+'/'+buildUid" [section]="this.curFloorId+'floordrawing-SVG'+buildUid" [autoPlay]="true"
        [showThumbs]="true"
        class="list-static simple-gall svg-gallery build-simple-gal plan-holder"></app-gallery>

        <!-- <app-drawing-floors class="floor-gallery"
        [drawingHolderWidth]="1000" [item]="this.curFloorId"></app-drawing-floors> -->

        <app-gallery *ngIf="!ifFloorIdIsFloorNumber(this.curFloorId)" [galleryId]="'1'" [section]="this.curFloorId+'floordrawing'" [autoPlay]="true"
          [showThumbs]="true" [resizeDrag]="true"
          class="list-static simple-gall build-simple-gal plan-holder"></app-gallery>
          <app-gallery *ngIf="ifFloorIdIsFloorNumber(this.curFloorId)" [galleryId]="'1'" [section]="this.curFloorId+'floordrawing'+buildUid" [autoPlay]="true"
          [showThumbs]="true" [resizeDrag]="true"
          class="list-static simple-gall build-simple-gal plan-holder"></app-gallery>
      </mat-tab>

      <mat-tab class="simulations">
        <ng-template mat-tab-label>
          <div class="lable-holder" (click)="openMenuMatTab('gal')">
            <mat-icon class="simulation-icon"></mat-icon>
            {{ 'SIMULATIONS-SHARED' | translate }}
          </div>
        </ng-template>
        <app-gallery *ngIf="this.currentFlatsOnClick.shareflatgallery" [galleryId]="'1'" [type]="'flyprop'"
          [section]="this.proj[0].uid+'interiorSimulations'" [autoPlay]="true" [showThumbs]="true"
          (isNoItems)="isNoItemsF($event, 'shareflatgallery')"
          class="list-static simulations flat-details shared-flat-gallery scroll">
        </app-gallery>
        <app-gallery *ngIf="this.currentFlatsOnClick.shareflatgalleryOfBuilding" [type]="'flyprop'" [galleryId]="'1'"
          [section]="this.building.uid+'interiorSimulations'" [autoPlay]="true" [showThumbs]="true"
          (isNoItems)="isNoItemsF($event, 'shareflatgalleryOfBuilding')"
          class="list-static flat-details simulations shared-flat-gallery scroll">
        </app-gallery>

        <app-gallery [galleryId]="'1'" [section]="this.currentFlatsOnClick.id+'interiorSimulations'" [type]="'flyprop'" [autoPlay]="true"
          [showThumbs]="true" class="list-static flat-details scroll simulations"
          (isNoItems)="isNoItemsF($event, 'simpleGallery')"></app-gallery>

          
      </mat-tab>

      
      
      
<!--       
      <mat-tab *ngIf="simpleGallery">
        <ng-template mat-tab-label>
          <div class="lable-holder" (click)="openMenuMatTab('gal')">
            <mat-icon class="simulation-icon"></mat-icon>
            {{ 'SIMULATIONS-INTERIOR' | translate }}
          </div>
        </ng-template>

        <app-gallery [galleryId]="'1'" 
          [section]="currentFlatsOnClick.id+'interiorSimulations'"
          [autoPlay]="true" [showThumbs]="true" class="list-static flat-details scroll"
          (isNoItems)="isNoItemsF($event, 'simpleGallery')"></app-gallery>

        <app-gallery *ngIf="currentFlatsOnClick.protoId" [galleryId]="'1'" 
          [section]="this.currentFlatsOnClick.protoId+'interiorSimulations'"
          [autoPlay]="true" [showThumbs]="true" class="list-static flat-details scroll"
          (isNoItems)="isNoItemsF($event, 'simpleGallery')"></app-gallery>
      </mat-tab>


      
      <mat-tab *ngIf="shareflatgallery">
        <ng-template mat-tab-label>
          <div class="lable-holder" (click)="openMenuMatTab('gal')">
            <mat-icon class="simulation-icon"></mat-icon>
            {{ 'SIMULATIONS-SHARED' | translate }}
          </div>
        </ng-template>
        <app-gallery *ngIf="this.currentFlatsOnClick.shareflatgallery"  [galleryId]="'1'" [type]="'mosaic'"
         [section]="this.proj[0].uid+'interiorSimulations'" [autoPlay]="true"
        [showThumbs]="true" (isNoItems)="isNoItemsF($event, 'shareflatgallery')"
        class="list-static flat-details shared-flat-gallery scroll">
      </app-gallery>
      <app-gallery *ngIf="this.currentFlatsOnClick.shareflatgalleryOfBuilding"
        [galleryId]="'1'" [section]="this.building.uid+'interiorSimulations'"
        [autoPlay]="true" [showThumbs]="true" (isNoItems)="isNoItemsF($event, 'shareflatgalleryOfBuilding')"
        class="list-static flat-details shared-flat-gallery scroll">
      </app-gallery>
      </mat-tab> -->

    </mat-tab-group>
  </div>



  

</div>
<ul class="data-on-the-fly general-flat-propeties n" id="data-on-the-fly" *ngIf="this.currentFlats">
  <li class="general-flat-number flat-number-title"> <span>{{ 'FLAT-NUMBER' | translate }}</span> {{
    this.currentFlats.number }}</li>
  <li class="floor-title"> <span>{{ 'FLOOR' | translate }}</span> {{ this.currentFlats.floorNumber }}</li>
  <li class="flat-size-title">
    <span>{{ 'APARTMENT-AREA' | translate }}</span> {{ this.currentFlats.flatSize }}
  </li>
  <!-- <li class="general-flat-area balconies-size-title">
          <span>{{ 'BALCONIES-AREA' | translate }}</span> {{ this.currentFlats.balconiesSize }}
        </li> -->
  <li class="general-flat-room-quantity numberOfRooms-title">
    <span>{{ 'NUMBER-OF-ROOMS' | translate }}</span> {{ this.currentFlats.numberOfRooms }}
  </li>
</ul>


<!-- <div @anim class="data-on-click"> -->
